import { Component, OnInit } from '@angular/core';
import { ChunkGeneric } from 'src/app/domain/views/chunk-generic.view';

import { Router } from '@angular/router';
import { NavigationConstants } from 'src/app/ui/commons/navigation.constants';
import { Pagination } from 'src/app/domain/views/pagination.view';
import { TranslateService } from '@ngx-translate/core';
import { marker as I18N } from '@biesbjerg/ngx-translate-extract-marker';
import { GuideResume } from 'src/app/business/models/guide/guide-resume.model';
import { ProviderGuideInteractor } from 'src/app/domain/interactor/provider/guide.interactor';


@Component({
  selector: 'app-list-guides',
  templateUrl: './list.component.html'
})
export class ListGuidesComponent implements OnInit  {

  guides: Array<GuideResume>;
  pagination: Pagination;

  desktopVersion: boolean;
  initialWindowSize: number;

  paginationNextLabel: string;
  paginationPreviousLabel: string;


  constructor(
       private providerGuideInteractor: ProviderGuideInteractor,
       private translateService: TranslateService,
       private router: Router ) {

      this.pagination = new Pagination(0, 1, 20);
      this.guides = new Array<GuideResume>();
      this.desktopVersion = true;

  }



  ngOnInit() {

      this.initialWindowSize = window.innerWidth;
      this.loadGuides(1);

      this.translateService.get(I18N('pagination.Siguiente')).subscribe(
           (messageTranslated: string) => {
                this.paginationNextLabel = messageTranslated;
           }
      )

      this.translateService.get(I18N('pagination.Previous')).subscribe(
           (messageTranslated: string) => {
                this.paginationPreviousLabel = messageTranslated;
           }
      )


  }


  onDesktopVersionUpdated( isDesktopVersion: boolean ) {
      this.desktopVersion = isDesktopVersion;
  }



  createGuide() {
      this.router.navigate( [ NavigationConstants.getNavigationProviderCreateGuide() ] );
  }


  onPageChanged( currentPage: number ) {
      this.loadGuides(currentPage);
  }


  loadGuides(currentPage: number) {
      this.providerGuideInteractor.findGuides(currentPage)
        .subscribe(
            (chunkResult: ChunkGeneric<GuideResume>) => {

                this.pagination = new Pagination(chunkResult.pagination.totalItems, chunkResult.pagination.currentPage, chunkResult.pagination.itemsPerPage);
                this.guides = chunkResult.items

            },
            () => {

            }

        )
  }


  onGuideClick( guideId: number ) {

      this.router.navigate([ NavigationConstants.getNavigationProviderGuideDetail(guideId) ]);

  }

}
